module.exports = __webpack_public_path__ + "static/1136278466-lunchtime-customers-eating-at-a-busy-restaurant-56addafb9f9c0633f9bac25a04dcc2e9.png";